import { render } from "./MPV.vue?vue&type=template&id=447d8c32"
import script from "./MPV.vue?vue&type=script&lang=js"
export * from "./MPV.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/MPV.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "447d8c32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('447d8c32', __exports__)) {
    api.reload('447d8c32', __exports__)
  }
  
  module.hot.accept("./MPV.vue?vue&type=template&id=447d8c32", () => {
    api.rerender('447d8c32', render)
  })

}


export default __exports__